const generateUrl = () => {

  if (window.location.href.includes('localhost') || window.location.href.includes('192.168.0.9')) {
    return "http://192.168.0.9:3001";
  } else {
    return "https://api.theprime.gg";
  }

}

export const url = generateUrl()


export const endpoints = {
  'pregister': 'pregister'
}

export const req = (endpoint: string) => {

  return fetch(`${url}/${endpoint}`)
    .then(response => response.json())
    .then((result) => {
      return result
    });


}